"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = require("react");
var IconContext = /*#__PURE__*/ (0, _react.createContext)({});
var _default = IconContext;
